import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {AMP, OP_A, OP_B1, OP_B2, FILTER, FILTER_2, PITCH, MODULATION} from 'constants/envelope-types.js';

const EnvelopeOptions = ({color, onChange, instrument, option, isSelected}) => { 
    let style = {
    };
    if (isSelected) {
        style.backgroundColor = color;
    }
    return (
        <div
          style={style}
          onClick={() => onChange(option)}
          className={isSelected ? "envelope-option selected" : "envelope-option"}>
          {option}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnvelopeOptions);
